import {
  ROUTE_CONCIERGE,
  ROUTE_GUARANTEED_HIRE,
  ROUTE_TEST_PAGE,
  ROUTE_MULTI_LOCATION,
  ROUTE_PREMIUM_PLUS,
} from 'src/app/constants/routes';

export const allowDirectRouteAccess = (route: string): boolean =>
  Boolean(route) &&
  (route.includes(ROUTE_TEST_PAGE) ||
    route.includes(ROUTE_CONCIERGE) ||
    route.includes(ROUTE_GUARANTEED_HIRE) ||
    route.includes(ROUTE_PREMIUM_PLUS) ||
    route.includes(ROUTE_MULTI_LOCATION));
